import { FormattedMessage } from 'react-intl';
import { Divider, Form, notification } from 'antd';

import { PageProps } from '@/types/PageProps';

import TabContentWrapper from '@/components/_common/TabContentWrapper';
import { SaveButton } from '@/components/_common/Buttons';
import InformativeForm from '@/components/Informative/form';

import { DateTimeFormat } from '@/utils/moment';
import { useEmployeeDetail } from '@/core/domain/enterprise/Employees/Employees.hooks';
import { useHistory } from 'react-router-dom';
import {
  InformativeCreateRequest,
  InformativeFormValues,
} from '@/core/domain/notification/Informative/Informative.types';
import { useInformativeCreate } from '@/core/domain/notification/Informative/Informative.hooks';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';

function CreateInformativePage({ route }: PageProps) {
  const history = useHistory();
  const [form] = Form.useForm<InformativeFormValues>();

  const createMutation = useInformativeCreate();

  const employeeMutation = useEmployeeDetail();

  const handleSaveClick = async () => {
    try {
      const values = await form.validateFields();

      if (values) {
        const employee = await employeeMutation.mutateAsync(values.employeeID);
        if (values.usersID.length) {
          const obj: InformativeCreateRequest = {
            employeeID: values.employeeID.toString(),
            employeeName: employee.name,
            sented: true,
            dataInformation: values.dataInformation.format(DateTimeFormat),
            message: values.message,
            usersID: values.usersID,
          };

          const response = await createMutation.mutateAsync(obj);

          history.push(`/app/informative/${response.id}`);
        } else {
          notification.error({
            message: 'Atenção!',
            description:
              'Não é possivel cadastrar um informativo sem ao menos marcar 1 usuário!',
          });
        }
      }
    } catch {}
  };

  return (
    <TabContentWrapper
      permissions={route.permissions}
      title={route.name}
      extra={
        <SaveButton
          type="primary"
          onClick={handleSaveClick}
          loading={employeeMutation.isLoading || createMutation.isLoading}
        >
          <FormattedMessage id="commons.entity.save" />
        </SaveButton>
      }
    >
      <InformativeForm form={form} />

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/informative" />
      </SpaceForButton>
    </TabContentWrapper>
  );
}

export default CreateInformativePage;
